import * as w from '@packages/systems/wfdl';
import * as wast from '@packages/systems/wfdl-ast';
import * as wq from '@packages/systems/wfdl-Qualified';

import {constantFalse} from '@packages/utilities/fp/utils';
import {isComposeExpressionVariable} from '@packages/systems/flows/shared';

const formTriggerVar = wq.qualify(
  wq.pluginName('Logic'),
  wq.identifier('formTrigger')
);

const isFormTriggerVariable = w.matchExpression({
  Variable: w.Variable.match({
    qualified: (name) => wq.namesEqual(name, formTriggerVar),
    unqualified: constantFalse,
  }),
  _: constantFalse,
});

/**
 * Gets the form plugin value (trigger) name. Here's the shape
 * of the whole expression:
 *
 * ```js
 * EFunction({
 *   param: 'Context',
 *   body: ECall({
 *     fun: ECall({
 *       fun: Expressions.qualifiedVariable('Effect', 'compose'),
 *       arg: ECall({
 *         fun: Expressions.qualifiedVariable('Logic', 'formTrigger'),
 *         arg: Expressions.qualifiedVariable(
 *           '__SitePlugins',
 *           'Email Form Name' // <-- THIS IS THE NAME WE'RE LOOKING FOR
 *         ),
 *       }),
 *     }),
 *     arg: EFunction({
 *       param: DEFAULT_TRIGGER_NAME,
 *       body: Expressions.qualifiedVariable('Effect', 'Done'),
 *     }),
 *   })
 * })
 * ```
 */
export const getFormPluginNameFromExpr = (
  expr: wast.Expression
): null | string => {
  const func = w.Expressions.getFunction(expr);
  if (!func) return null;
  const {fun, args} = w.Expressions.deconstructCall(func.body);
  if (args.length !== 2 || !isComposeExpressionVariable(fun)) return null;
  const parser = args[0];
  // @ts-expect-error - TS2345 - Argument of type 'Expression | undefined' is not assignable to parameter of type 'ExpressionF<Expression>'.
  const parserCall = w.Expressions.getCall(parser);
  if (!parserCall) return null;

  if (!isFormTriggerVariable(parserCall.fun)) return null;

  const formNameVar = w.Expressions.getVariable(parserCall.arg);
  const formName = formNameVar ? w.Variable.getName(formNameVar) : null;
  return formName;
};
